import React from 'react';
import { Link } from 'react-router-dom';
import SEOHead from '../components/SEOHead';
import { BreadcrumbSchema } from '../components/JsonLdSchema';

const highlights = [
  { icon: '🧾', label: 'Fast Billing & GST Invoicing' },
  { icon: '📦', label: 'Inventory Management' },
  { icon: '☁️', label: 'Cloud & Multi-Device Sync' },
  { icon: '📊', label: 'Business Analytics' },
  { icon: '🔗', label: 'Payment & Aggregator Integrations' },
  { icon: '📱', label: 'QR Ordering & Online Orders' },
];

export default function About() {
  return (
    <main style={{ paddingTop: 64 }}>
      <SEOHead
        title="About DPOS – Restaurant Management Platform | DGPOS LLP"
        description="DPOS is a modern restaurant management platform that simplifies billing, inventory, kitchen operations, and analytics for restaurants and cloud kitchens."
        canonical="/about"
      />
      <BreadcrumbSchema items={[
        { name: 'Home', path: '/' },
        { name: 'About' },
      ]} />

      {/* Hero */}
      <section style={{ background: 'linear-gradient(135deg, #fff 0%, #fef2f2 50%, #fff 100%)', padding: '72px 24px 56px' }}>
        <div style={{ maxWidth: 800, margin: '0 auto', textAlign: 'center' }}>
          <span style={{ fontSize: 11, fontWeight: 700, color: '#CC0000', textTransform: 'uppercase', letterSpacing: '0.1em' }}>DGPOS LLP</span>
          <h1 style={{ fontSize: 'clamp(32px, 4vw, 52px)', fontWeight: 800, color: '#111827', lineHeight: 1.15, margin: '12px 0 8px' }}>
            About DPOS
          </h1>
          <p style={{ fontSize: 16, color: '#6b7280', fontWeight: 600, margin: '8px 0 0' }}>
            DPOS stands for Dynamic Point of Sale.
          </p>
          <img src="/logo-header.png" alt="DPOS" style={{ height: 56, margin: '24px auto 0', display: 'block' }} />
        </div>
      </section>

      {/* Content */}
      <section style={{ padding: '56px 24px 80px', background: '#fff' }}>
        <div style={{ maxWidth: 760, margin: '0 auto' }}>
          <p style={{ fontSize: 16, color: '#374151', lineHeight: 1.85, marginBottom: 20 }}>
            DPOS, short for Dynamic Point of Sale, is a modern restaurant management platform designed to simplify daily business operations through smart digital solutions. The software is available for mobile, desktop, tablet, and cloud-based environments, allowing businesses to manage operations from anywhere.
          </p>
          <p style={{ fontSize: 16, color: '#374151', lineHeight: 1.85, marginBottom: 20 }}>
            DPOS provides fast billing, GST invoicing, inventory management, kitchen order management, customer handling, payment integration, and detailed business analytics in a single system. The platform supports restaurants, cafés, cloud kitchens, QSRs, fine dining, bakeries, and retail businesses with real-time order tracking and centralized management.
          </p>
          <p style={{ fontSize: 16, color: '#374151', lineHeight: 1.85, marginBottom: 20 }}>
            It also offers QR ordering, online order integration, multi-device synchronization, and automated reporting to improve operational efficiency. DPOS helps businesses reduce manual work, improve billing speed, manage stock accurately, and deliver a better customer experience.
          </p>
          <p style={{ fontSize: 16, color: '#374151', lineHeight: 1.85, marginBottom: 40 }}>
            The software includes smart integrations with payment gateways, food aggregators, printers, and kitchen display systems for seamless workflow automation. DPOS focuses on user-friendly design, secure operations, and reliable performance to help businesses scale smoothly and manage multiple outlets effectively.
          </p>

          {/* Highlights */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: 12, marginBottom: 48 }}>
            {highlights.map(h => (
              <div key={h.label} style={{ display: 'flex', alignItems: 'center', gap: 10, background: '#f9fafb', borderRadius: 10, padding: '14px 16px', border: '1px solid #e5e7eb' }}>
                <span style={{ fontSize: 20 }}>{h.icon}</span>
                <span style={{ fontSize: 14, fontWeight: 600, color: '#111827' }}>{h.label}</span>
              </div>
            ))}
          </div>

          <div style={{ textAlign: 'center' }}>
            <Link to="/contact" style={{ background: '#CC0000', color: '#fff', padding: '12px 28px', borderRadius: 8, fontWeight: 600, fontSize: 15, display: 'inline-block' }}>
              Contact for Free Demo →
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}
